import { ClientSdkPublicInterface } from "../sdk/ClientSdkPublicInterface.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { isArray, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { TopicObj } from "../api/types/NotificationDataTypes.js";



interface SuggestedFollow {

    url: string,
    label?: string

}


function isSuggestedFollow(obj: any): obj is  SuggestedFollow {
    return isObject(obj) && hasOwnProperty(obj, "url");
}

export class FollowSuggestionUtil {



    constructor(
        private readonly sdk: ClientSdkPublicInterface,
        private readonly logger: Logger
    ) {

    }


    public getPageSuggestedTopic(): Promise<TopicObj|null> {
        const Fanpage = window['Fanpage'] || {};
        const suggestedFollows: SuggestedFollow[] = [];
        this.logger.debug("In page suggestion", Fanpage.SuggestedFollows);
        if(Fanpage && Fanpage.SuggestedFollows) {
            if(!isArray(Fanpage.SuggestedFollows)) {
                suggestedFollows.push(Fanpage.SuggestedFollows);
            }
            else {
                Fanpage.SuggestedFollows.forEach(sf => {
                    if(isSuggestedFollow(sf)) suggestedFollows.push(sf);
                });
            }
        }
        else {
            this.logger.debug("No suggested topics in page");
        }
        this.logger.debug("Suggested Follows to Check", suggestedFollows);
        return suggestedFollows.reduce<Promise<TopicObj>>( (promise, sf) => {
            return promise.then(searchedTopic => {
                if (searchedTopic != null) return searchedTopic;

                this.logger.debug("Looking for topic",  sf);
                return this.sdk.resolve(sf.url).then(
                    res => {
                        if (res && res.data && res.data.topic) {
                            const topic = res.data.topic;
                            this.logger.debug("topic was found", topic);
                            if (topic && topic.followable && !topic.followed) {
                                this.logger.debug("topic is followable");
                                return topic;
                            }
                            else {
                                this.logger.debug("topic filtered out");
                                return null;
                            }
                        }
                        else {
                            return null;
                        }
                    }
                ).catch(e => {
                    this.logger.error("There was an error extracting topic", e);
                    return Promise.resolve(null);
                });
            });
        }, Promise.resolve(null));
        
    }


}